var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40103",
    "data-name": "Group 40103",
    transform: "translate(-812.78 -301.78)",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82792",
    "data-name": "Path 82792",
    d: "M106.25,191.428c-22.686,0-45.371-.035-68.056.022-6.566.016-11.707-2.4-15.12-8.118a16.975,16.975,0,0,1-2.133-8.954q.033-44.456.013-88.913,0-8.125,0-16.251c.011-10.253,6.635-16.994,16.873-17.023,16.47-.048,32.94-.013,49.411-.013,7.52,0,15.042.065,22.561-.019a16.54,16.54,0,0,1,14.893,7.933c3.5,5.291,7.167,10.469,10.659,15.764a3.733,3.733,0,0,0,3.57,1.947c11.932-.086,23.866-.051,35.8-.043,10.286.006,17.044,6.773,17.047,17.081q.01,39.694,0,79.387c0,10.485-6.62,17.18-17.089,17.193q-34.215.04-68.43.008m-.057-3.832q34.4,0,68.8,0c7.849,0,12.969-5.1,12.974-12.968q.027-39.972-.015-79.944a16.125,16.125,0,0,0-.531-4.237c-1.533-5.54-6.2-8.838-12.53-8.859-11.187-.037-22.374-.011-33.561-.011q-21.442,0-42.884.022c-1.475,0-2.667-.224-3.47-1.611-.43-.742-1.089-1.346-1.577-2.059q-5.53-8.084-11.032-16.188A11.76,11.76,0,0,0,72.351,56.2q-17.805-.117-35.611-.007A11.724,11.724,0,0,0,25.108,67.484c-.184,4.842-.341,9.69-.345,14.535q-.046,46.043-.014,92.086c0,8.5,4.949,13.49,13.39,13.491q34.028.005,68.054,0M83.082,56.01c1.459,2,2.776,3.727,4,5.513q5.122,7.45,10.163,14.955a2.548,2.548,0,0,0,2.406,1.306c10.184-.044,20.368-.023,30.551-.031.5,0,1.009-.086,1.749-.152-3.708-5.451-7.237-10.633-10.758-15.82A12.459,12.459,0,0,0,110.169,56c-8.507.047-17.014.013-25.522.013Z",
    transform: "translate(801.629 274.962)",
    fill: "#6d6e70",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82794",
    "data-name": "Path 82794",
    d: "M145.689,59.879h1.566c8.507,0,17.015.034,25.522-.013A12.459,12.459,0,0,1,183.8,65.648c3.521,5.187,7.051,10.369,10.758,15.82-.74.067-1.244.152-1.749.152-10.183.008-20.367-.012-30.551.031a2.548,2.548,0,0,1-2.406-1.306q-5.024-7.516-10.163-14.955c-1.228-1.786-2.545-3.51-4-5.513",
    transform: "translate(739.022 271.094)",
    fill: "#faaf40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82795",
    "data-name": "Path 82795",
    d: "M191.716,171.258c-.342,7.809-.566,13.4-.84,18.991-.161,3.291-2.259,5.458-5.177,5.455s-5.009-2.178-5.166-5.468q-.772-16.213-1.485-32.428c-.191-4.424,2.615-7.536,6.662-7.53s6.832,3.109,6.651,7.543c-.213,5.219-.5,10.435-.646,13.436m-3.465-11.509c0-.674,0-1.483,0-2.291,0-2.1-.855-3.13-2.567-3.122s-2.573,1.045-2.514,3.16q.162,5.777.431,11.55c.327,6.951.67,13.9,1.086,20.846.033.556.677,1.076,1.037,1.613.349-.549.975-1.083,1.006-1.65.548-9.987,1.024-19.979,1.522-30.1",
    transform: "translate(722.285 225.719)",
    fill: "#6d6e70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82796",
    "data-name": "Path 82796",
    d: "M334.326,167.743q0-8.762,0-17.525c0-.558-.157-1.243.1-1.646.416-.644,1.107-1.5,1.709-1.526.623-.023,1.4.748,1.875,1.356.282.361.14,1.077.141,1.633q.008,17.618,0,35.237c0,.373.014.748-.015,1.118a1.858,1.858,0,0,1-2.013,1.97,1.767,1.767,0,0,1-1.784-1.973c-.016-1.243-.02-2.486-.02-3.729q0-7.458,0-14.915",
    transform: "translate(644.374 227.342)",
    fill: "#6d6e70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82797",
    "data-name": "Path 82797",
    d: "M178.513,261.422c-.333-6.362,5.321-8.895,9.013-7.547a6.444,6.444,0,0,1,4.663,5.686,14.886,14.886,0,0,1-.26,4.97,6.646,6.646,0,0,1-7.328,4.7,6.781,6.781,0,0,1-5.963-5.949c-.075-.614-.085-1.236-.126-1.855m9.785.016c0-2.536-.9-3.723-2.823-3.759a2.507,2.507,0,0,0-2.8,2.193c-.329,2.486-.348,4.129,1.566,5.089,2.186,1.1,4.054-.532,4.054-3.523",
    transform: "translate(722.556 173.904)",
    fill: "#6d6e70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82798",
    "data-name": "Path 82798",
    d: "M334.369,252.735c0-3.109.006-6.219,0-9.329,0-1.364.266-2.627,1.936-2.583,1.622.043,1.906,1.29,1.9,2.659q-.016,9.235,0,18.47c0,1.372-.265,2.625-1.89,2.666-1.809.045-1.96-1.337-1.954-2.742.013-3.047,0-6.095,0-9.142",
    transform: "translate(644.333 180.278)",
    fill: "#6d6e70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82799",
    "data-name": "Path 82799",
    d: "M192.409,163.836c-.5,10.126-.974,20.118-1.522,30.1-.031.567-.657,1.1-1.006,1.65-.36-.537-1-1.057-1.037-1.613-.416-6.946-.759-13.9-1.086-20.846q-.271-5.772-.431-11.55c-.059-2.115.816-3.152,2.514-3.16s2.563,1.026,2.567,3.122c0,.808,0,1.616,0,2.291",
    transform: "translate(718.127 221.631)",
    fill: "#faaf40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82800",
    "data-name": "Path 82800",
    d: "M192.339,265.624c0,2.991-1.868,4.62-4.054,3.523-1.914-.961-1.895-2.6-1.566-5.089a2.507,2.507,0,0,1,2.8-2.193c1.922.037,2.823,1.224,2.823,3.759",
    transform: "translate(718.516 169.718)",
    fill: "#faaf40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15793",
    "data-name": "Rectangle 15793",
    width: 190,
    height: 190,
    transform: "translate(812.78 301.78)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default __webpack_public_path__ + "static/media/file-error.7e97e6f1fef29bc7be77724ba738fb93.svg";
export { ForwardRef as ReactComponent };